module.exports = __webpack_public_path__ + "static/media/chatMessageSending_3.ee0d0220.mp3";